<template>
    <div class="main_data_div no-border" style="padding: 0px 15px;">
      <div class="col-md-12 col-xs-12" style="padding: 0px; margin-bottom: 10px;"  v-if="localRemindSingle">
        <div class="row padding_0px"  >
            <div class="col-md-1 col-xs-1 padding_0px">
                <as :href="`/settings/user-info/${localRemindSingle.user_id}`" target="_blank"><img :src="localRemindSingle.avatar_link" width="30"></as>
            </div>
          <div class="col-md-9 col-xs-9 padding_0px padding_18_mobiles">
              <span ><b>{{localRemindSingle.user}}</b></span>
              <br/>
              <span>{{localRemindSingle.contact_history_created_converted}}</span>
          </div>
            <div class="col-md-2 col-xs-2 padding_0px">
                <div class="d-inline clickable customer-property-item-icon margin-right-20 float-right" title="Delete contact attempt"
                     @click="deleteProperty(localRemindSingle.contact_history_id, itemId)" style="margin-top:15px ">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_5011_11480)">
                            <path d="M16 9V19H8V9H16ZM14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM18 7H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7Z" fill="#F44336"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_5011_11480">
                                <rect width="24" height="24" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>
                </div>
            </div>
          <div class="col-md-12 col-xs-12 padding_0px" >
                <textarea class="form-control" readonly>{{localRemindSingle.comment}}</textarea>
          </div>
<!--          <div class="col-md-12" style="margin-top: 20px;">-->
<!--             -->
<!--          </div>-->
        </div>
      </div>

    </div>


</template>

<script>


import {EventBus} from "@/events/event-bus";
import {iSMobileDevice} from "@/events/sharedMethods";
import {deleteReminderView} from "@/modules/Booking/api/contactReminder/";
import ConfirmationPopup from "../../../common/components/ConfirmationPopup.vue";

export default {
    name: "reminderSingleView",
    components: {ConfirmationPopup},
    props: {
        remindSingle:'',
        itemId: '',
    },
    data() {
        return {
            localRemindSingle:this.remindSingle,
        }
    },

    mounted() {
        this.initiateListeners();
    },
    methods: {
        deleteProperty(id, inquiryId){
            deleteReminderView(id, inquiryId).then(response => {
                $.notify('Deleted reminder successfuly', 'success');
                EventBus.$emit('onDeletedReminder', response.data)
            });
        },
        initiateListeners(){
            EventBus.$on('viewSingleModal', reminder => {
                this.localRemindSingle =  reminder;
            })
        }
    },
    watch: {

    }
}


</script>

<style scoped>
.location_icon_section_title{
    color: var(--Navy, #2E4051);
    /* Title/Left/H4 */
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 120% */
}
.padding_0px{
    padding: 0px !important;
}
textarea.form-control{
    height: auto !important;
}
@media (max-width: 768px) {
    .no-border{
        border:  0px solid #000;
    }
    .padding_18_mobiles{
        padding: 0px 15px !important;
    }
}
</style>